import { CATEGORIES, EVENTS } from "@/mocks/gossip";

export default function CategoryStrip() {
  return (
    <section id="category" className="bg-paper-100 border-y border-ink-200/60 py-12 md:py-20 scroll-mt-24">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between flex-wrap gap-3">
          <div>
            <p className="text-sm font-semibold text-brand-600 mb-2 kicker-line">栏目导览</p>
            <h2 className="font-heading font-black text-3xl md:text-4xl text-ink-900">分类瓜田</h2>
          </div>
          <a
            href="#hot"
            className="inline-flex items-center gap-1.5 text-sm font-semibold text-brand-600 hover:text-brand-700 whitespace-nowrap"
          >
            回到实时热瓜榜
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {CATEGORIES.map((c, i) => {
            const sample = EVENTS.find((e) => e.category === c.name);
            return (
              <a
                key={c.id}
                href="#hot"
                className={`group relative overflow-hidden rounded-2xl border border-ink-200/60 p-6 bg-paper-50 card-lift hover:-translate-y-1 hover:border-brand-300 hover:shadow-soft ${
                  i % 3 === 1 ? "bg-brand-50" : i % 3 === 2 ? "bg-amber-50" : "bg-paper-50"
                }`}
              >
                <span className="absolute -right-2 -top-4 font-heading font-black text-[88px] leading-none text-ink-900/5 select-none">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <div className="relative">
                  <div className="flex items-start justify-between">
                    <h3 className="font-heading font-black text-2xl text-ink-900 group-hover:text-brand-600 transition-colors">
                      {c.name}
                    </h3>
                    <span className="text-xs px-2 py-1 rounded-full bg-ink-900 text-paper-50">已收录 {c.count}</span>
                  </div>
                  <p className="mt-2 text-sm text-ink-600">{c.desc}</p>
                  {sample && (
                    <p className="mt-4 text-xs text-ink-500 border-l-2 border-brand-300 pl-2.5 leading-relaxed line-clamp-2">
                      <span className="text-brand-600 font-semibold mr-1">最近在更</span>
                      {sample.title}
                    </p>
                  )}
                  <span className="mt-4 inline-flex items-center gap-1 text-sm font-semibold text-brand-600 group-hover:gap-2 transition-all">
                    去逛逛
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </a>
            );
          })}
        </div>
      </div>
    </section>
  );
}